export default __webpack_public_path__ + "static/media/wedding.4610f414.jpg";